import { render, staticRenderFns } from "./CardAgentCourier.vue?vue&type=template&id=bd7cb54e&"
import script from "./CardAgentCourier.vue?vue&type=script&lang=js&"
export * from "./CardAgentCourier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports